import React, { useMemo } from 'react';

// 🎨 문자열 기반 고유 파스텔톤 색상 자동 생성 헬퍼 함수
const generateDynamicTheme = (str) => {
    if (!str) return { bg: '#f1f5f9', color: '#475569', border: '#cbd5e1' };
    
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const h = Math.abs(hash) % 360;
    return {
        bg: `hsl(${h}, 85%, 96%)`,      
        color: `hsl(${h}, 75%, 35%)`,   
        border: `hsl(${h}, 70%, 88%)`   
    };
};

const SalesActivityTimeline = ({ clientActionList = [], searchYear }) => {
    // 🎯 백엔드에서 내려주는 실제 한글명 필드(actionName)를 기반으로 최종 바인딩
    const processedActivities = useMemo(() => {
        return clientActionList.map(activity => {
            const displayType = activity.actionName || '미지정';
            const theme = generateDynamicTheme(displayType);

            return {
                ...activity,
                displayType, 
                typeBg: theme.bg,
                typeColor: theme.color,
                typeBorder: theme.border
            };
        });
    }, [clientActionList]);

    const hasData = processedActivities.length > 0;

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
            {/* 컴포넌트 타이틀 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                <h2 style={{ margin: 0, fontWeight: '700', fontSize: '14px', color: '#1f2937' }}>
                    {searchYear}년 영업활동 내역
                </h2>
            </div>

            {/* 독립된 스크롤 가능 그리드 박스 */}
            <div style={{
                width: '100%',
                maxHeight: '560px', 
                minHeight: '560px', 
                overflowY: 'auto',   
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                // 🎯 [교정] 데이터가 없을 때는 내부 상하 패딩을 지워야 상하 정중앙이 칼같이 맞습니다.
                padding: hasData ? '16px 16px 16px 20px' : '0',
                backgroundColor: '#ffffff',
                boxSizing: 'border-box',
                // 🎯 [추가] 데이터가 없을 때만 요소를 정중앙 배치하는 Flex 레이아웃 적용
                display: hasData ? 'block' : 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                {hasData ? (
                    <div style={{
                        position: 'relative',
                        borderLeft: '1px solid #d1d5db',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        boxSizing: 'border-box',
                        paddingLeft: '16px'
                    }}>
                        {processedActivities.map((activity) => (
                            <div key={activity.actionId} style={{ position: 'relative' }}>
                                
                                {/* 타임라인 원형 노드 */}
                                <div style={{
                                    position: 'absolute',
                                    left: '-21px', 
                                    top: '4px',
                                    backgroundColor: '#ffffff',
                                    width: '7px',
                                    height: '7px',
                                    borderRadius: '50%',
                                    border: '2px solid #4b5563',
                                    boxShadow: '0 0 0 4px #ffffff'
                                }} />

                                {/* 히스토리 콘텐츠 상세 본문 */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    
                                    {/* 헤더 : 날짜와 백엔드가 제공한 실제 actionName 배지 */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
                                        <span style={{ fontWeight: '600', color: '#9ca3af' }}>📅 {activity.startDatetime}</span>
                                        <span style={{
                                            padding: '1px 6px',
                                            borderRadius: '4px',
                                            border: `1px solid ${activity.typeBorder}`,
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            backgroundColor: activity.typeBg,
                                            color: activity.typeColor,
                                            display: 'inline-block',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {activity.displayType}
                                        </span>
                                    </div>

                                    {/* 바디 : 주요 활동 기록 설명 문구 */}
                                    <p style={{ 
                                        margin: 0, 
                                        fontSize: '12px', 
                                        color: '#374151', 
                                        fontWeight: '500', 
                                        lineHeight: '1.4' 
                                    }}>
                                        {activity.title}
                                    </p>

                                    {/* 푸터 : 담당실무자 이름 */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#9ca3af' }}>
                                        <span>👤 담당자:</span>
                                        <span style={{ color: '#6b7280', fontWeight: '500' }}>{activity.usrNm || '미지정'}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    // 🎯 [교정] 데이터가 없을 때 560px 박스 가로/세로 영역의 '정중앙'에 노출될 안내 문구
                    <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: '12px', fontWeight: '500' }}>
                        연관된 영업활동 내역이 존재하지 않습니다.
                    </div>
                )}
            </div>
        </div>
    );
};

export default SalesActivityTimeline;
